<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs12 sm6>
        <v-btn
          href="javascript:void(0)"
          class="btn"
          :color="filter == 'all' ? 'primary' : 'default'"
          @click="
            filter = 'all'
            getData()
          "
          >{{ $t('All') }}</v-btn
        >

        <v-btn
          :color="filter == 'facebook' ? 'primary' : 'default'"
          @click="
            filter = 'facebook'
            getData()
          "
        >
          <em class="fab fa-facebook-square mr-2" />
          {{ $t('Facebook') }}
        </v-btn>
        <v-btn
          href="javascript:void(0)"
          :color="filter == 'line' ? 'primary' : 'default'"
          @click="
            filter = 'line'
            getData()
          "
        >
          <em class="fab fa-line mr-2" />
          {{ $t('Line') }}
        </v-btn>
      </v-flex>
      <v-flex xs12 sm6 class="text-xs-right">
        <v-btn outline :loading="loading" color="grey" @click="exportKasikornCareer">
          <span class="fas fa-file-export"></span>
          {{ $t('export') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <div class="my-3">
      <v-btn
        small
        :color="currentFilter == 'all' ? 'primary' : 'default'"
        @click="changeDate('all')"
        >{{ $t('All') }}</v-btn
      >
      <v-btn
        small
        :color="currentFilter == 'today' ? 'primary' : 'default'"
        @click="changeDate('today')"
        >{{ $t('today') }}</v-btn
      >
      <v-btn
        small
        :color="currentFilter == 'this_month' ? 'primary' : 'default'"
        @click="changeDate('this_month')"
        >{{ $t('this month') }}</v-btn
      >
      <v-btn
        small
        :color="currentFilter == 'this_year' ? 'primary' : 'default'"
        @click="changeDate('this_year')"
        >{{ $t('this year') }}</v-btn
      >
      <v-btn
        small
        :color="currentFilter == 'last_month' ? 'primary' : 'default'"
        @click="changeDate('last_month')"
        >{{ $t('last 30 days') }}</v-btn
      >
      <v-btn
        small
        :color="currentFilter == 'last_365_day' ? 'primary' : 'default'"
        @click="changeDate('last_365_day')"
        >{{ $t('last 365 days') }}</v-btn
      >
      <v-btn
        small
        :color="currentFilter == 'custom_date' ? 'primary' : 'default'"
        @click="changeDate('custom_date')"
        >{{ $t('Custom Date') }}</v-btn
      >
    </div>
    <v-layout v-if="currentFilter == 'custom_date'" wrap class="mt-2">
      <v-flex xs12 sm6>
        <span class="dashboard_datepicker">
          {{ $t('from') }}:
          <datepicker
            v-model="selectedDate.start"
            style="margin-bottom: 10px"
            @selected="onSelectedStartDate"
          ></datepicker>
        </span>
      </v-flex>
      <v-flex xs12 sm6>
        <span class="dashboard_datepicker" style="margin-bottom: 10px">
          {{ $t('to') }}:
          <datepicker v-model="selectedDate.end" style @selected="onSelectedEndDate"></datepicker>
        </span>
      </v-flex>
    </v-layout>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="customers"
      class="elevation-1"
      :pagination.sync="pagination"
      :rows-per-page-items="[25, 45, 65, { text: $t('All'), value: -1 }]"
      :rows-per-page-text="$t('Rows per page')"
    >
      <template #items="props">
        <td>
          <v-avatar size="30">
            <img
              v-if="props.item.profile_pic"
              :src="props.item.profile_pic"
              width="30"
              height="30"
              :alt="props.item.first_name"
              @error="onFailLoad"
            />
            <img
              v-else
              :src="'/static/img/assets/livechat/profile.png'"
              width="30"
              height="30"
              :alt="props.item.first_name"
            />
          </v-avatar>
        </td>
        <td>{{ props.item.first_name }}</td>
        <td>{{ props.item.email }}</td>
        <td>{{ props.item.level }}</td>
        <td>{{ $t(props.item.gender) }}</td>
        <td>{{ props.item.education }}</td>
        <td>{{ props.item.position }}</td>
        <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
        <td>
          {{
            props.item.informationanddataliteracy != null
              ? `${
                  props.item.informationanddataliteracy
                } (${props.item.informationanddataliteracy_percent.toFixed(2)}%)`
              : ''
          }}
        </td>
        <td>
          {{
            props.item.communicationandcollaboration != null
              ? `${
                  props.item.communicationandcollaboration
                } (${props.item.communicationandcollaboration_percent.toFixed(2)}%)`
              : ''
          }}
        </td>
        <td>
          {{
            props.item.digitalcontentintegration != null
              ? `${
                  props.item.digitalcontentintegration
                } (${props.item.digitalcontentintegration_percent.toFixed(2)}%)`
              : ''
          }}
        </td>
        <td>
          {{
            props.item.cybersecurityandresponsibility != null
              ? `${
                  props.item.cybersecurityandresponsibility
                } (${props.item.cybersecurityandresponsibility_percent.toFixed(2)}%)`
              : ''
          }}
        </td>
        <td>
          {{
            props.item.technicalproblemshandling != null
              ? `${
                  props.item.technicalproblemshandling
                } (${props.item.technicalproblemshandling_percent.toFixed(2)}%)`
              : ''
          }}
        </td>
        <td>
          {{
            props.item.careerresult3 != null
              ? `${props.item.careerresult3} (${props.item.careerresult3_percent.toFixed(2)}%)`
              : ''
          }}
        </td>
      </template>
    </v-data-table>
    <div class="mb-5"></div>
  </v-container>
</template>

<script>
import api from '@/api'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
export default {
  components: {
    datepicker
  },
  data() {
    return {
      headers: [
        { text: '', value: '', sortable: false },
        { value: 'first_name', text: 'first_name' },
        { value: 'email', text: 'email' },
        { value: 'level', text: 'age' },
        { value: 'gender', text: 'gender' },
        { value: 'education', text: 'education' },
        { value: 'position', text: 'position' },
        { value: 'timestamp', text: 'timestamp' },
        { value: 'informationanddataliteracy', text: 'Information and Dataliteracy' },
        { value: 'communicationandcollaboration', text: 'Communication and Collaboration' },
        { value: 'digitalcontentintegration', text: 'Digital Content Integration' },
        { value: 'cybersecurityandresponsibility', text: 'Cyber Security and Responsibility' },
        { value: 'technicalproblemshandling', text: 'Technical Problem Shandling' },
        { value: 'careerresult3', text: 'careerresult3' }
      ],
      pagination: { sortBy: 'timestamp', descending: true, rowsPerPage: 25 },
      loading: true,
      filter: 'all',
      selectedDate: {
        start: moment().toDate(),
        end: moment().toDate()
      },
      currentFilter: 'all',
      customers: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    onFailLoad: function (event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    changeDate: function (value) {
      var vm = this
      vm.currentFilter = value
      switch (value) {
        case 'all':
          vm.onSelectedDate()
          break
        case 'today':
          vm.selectedDate.start = moment().toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break

        case 'last_month':
          vm.selectedDate.start = moment().subtract(1, 'months').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break

        case 'this_month':
          vm.selectedDate.start = moment().startOf('month').toDate()
          vm.selectedDate.end = moment().endOf('month').toDate()
          vm.onSelectedDate()
          break

        case 'this_year':
          vm.selectedDate.start = moment().startOf('year').toDate()
          vm.selectedDate.end = moment().endOf('year').toDate()
          vm.onSelectedDate()
          break

        case 'last_365_day':
          vm.selectedDate.start = moment().subtract(365, 'days').toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break

        case 'custom_date':
          vm.selectedDate.start = moment().toDate()
          vm.selectedDate.end = moment().toDate()
          vm.onSelectedDate()
          break
      }
    },
    onSelectedStartDate: function (value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(this.selectedDate.end).isBefore(value)) {
        this.selectedDate.end = value
      }
      this.selectedDate.start = value
      this.getData()
    },
    onSelectedEndDate: function (value) {
      var vm = this
      vm.currentFilter = 'custom_date'
      if (moment(value).isBefore(this.selectedDate.start)) {
        this.selectedDate.start = value
      }
      this.selectedDate.end = value
      this.getData()
    },
    onSelectedDate: function (value) {
      this.getData()
    },
    getData: function () {
      var vm = this
      vm.loading = true

      vm.getKasikornCareerResult3().then(
        (customers) => {
          vm.customers = customers
          vm.loading = false
        },
        (error) => {
          vm.loading = false
        }
      )
    },
    getKasikornCareerResult3() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          app: vm.filter
        }
        if (vm.currentFilter != 'all') {
          data.datefrom = moment(vm.selectedDate.start).format('YYYY-MM-DD')
          data.dateto = moment(vm.selectedDate.end).format('YYYY-MM-DD')
        }
        api.getKasikornCareerResult3(data, function (error, response) {
          if (error) {
            reject(error)
            return
          }
          if (response.data) {
            var result = []
            response.data.map((val) => {
              var row = val
              row.informationanddataliteracy_percent = val.informationanddataliteracy
                ? (val.informationanddataliteracy / 15) * 100
                : 0
              row.communicationandcollaboration_percent = val.communicationandcollaboration
                ? (val.communicationandcollaboration / 18) * 100
                : 0
              row.digitalcontentintegration_percent = val.digitalcontentintegration
                ? (val.digitalcontentintegration / 15) * 100
                : 0
              row.cybersecurityandresponsibility_percent = val.cybersecurityandresponsibility
                ? (val.cybersecurityandresponsibility / 18) * 100
                : 0
              row.technicalproblemshandling_percent = val.technicalproblemshandling
                ? (val.technicalproblemshandling / 24) * 100
                : 0

              row.careerresult3_percent =
                (row.informationanddataliteracy_percent +
                  row.communicationandcollaboration_percent +
                  row.digitalcontentintegration_percent +
                  row.cybersecurityandresponsibility_percent +
                  row.technicalproblemshandling_percent) /
                5

              result.push(row)
            })
            resolve(result)
          } else {
            reject()
          }
        })
      })
    },
    exportKasikornCareer: function () {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }

      csvContent +=
        'userid,	name,	email,	age,	gender,education ,position,	timestamp,	Information and Dataliteracy,	Communication and Collaboration,	Digital Content Integration,	Cyber Security and Responsibility,	Technical Problem Shandling,	careerresult3\r\n'
      vm.customers.map((val, index) => {
        csvContent += '"' + val.id + '",'
        csvContent +=
          '"' + (val.first_name != null ? val.first_name.replace(/\r?\n|\r/g, ' / ') : '') + '",'
        csvContent += '"' + (val.email != null ? val.email.replace(/\r?\n|\r/g, ' / ') : '') + '",'
        csvContent += '"' + val.level + '",'
        csvContent += '"' + (val.gender ? val.gender : '') + '",'
        csvContent += '"' + (val.education ? val.education : '') + '",'
        csvContent += '"' + val.position + '",'

        csvContent += '"' + val.timestamp + '",'
        csvContent +=
          '"' +
          (val.informationanddataliteracy != null
            ? `${val.informationanddataliteracy} (${val.informationanddataliteracy_percent.toFixed(
                2
              )}%)`
            : '') +
          '",'
        csvContent +=
          '"' +
          (val.communicationandcollaboration != null
            ? `${
                val.communicationandcollaboration
              } (${val.communicationandcollaboration_percent.toFixed(2)}%)`
            : '') +
          '",'
        csvContent +=
          '"' +
          (val.digitalcontentintegration != null
            ? `${val.digitalcontentintegration} (${val.digitalcontentintegration_percent.toFixed(
                2
              )}%)`
            : '') +
          '",'
        csvContent +=
          '"' +
          (val.cybersecurityandresponsibility != null
            ? `${
                val.cybersecurityandresponsibility
              } (${val.cybersecurityandresponsibility_percent.toFixed(2)}%)`
            : '') +
          '",'
        csvContent +=
          '"' +
          (val.technicalproblemshandling != null
            ? `${val.technicalproblemshandling} (${val.technicalproblemshandling_percent.toFixed(
                2
              )}%)`
            : '') +
          '",'
        csvContent +=
          '"' +
          (val.careerresult3 != null
            ? `${val.careerresult3} (${val.careerresult3_percent.toFixed(2)}%)`
            : '') +
          '",'
        csvContent += '\r\n'
      })

      vm.exportCsv(csvContent, 'career_result')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/kasikorn/KasikornDigitalSkill.vue